/*
 * md-zoom.js
 * Abre dialog fullscreen de zoom ao clicar na galeria principal
 * (.product__media-item ou .md-zoom-abrir ou [data-md-zoom-abrir]).
 * Fecha com ESC (nativo) ou botao X. Scroll-snap horizontal entre fotos;
 * miniaturas atualizam o estado aria-current conforme o scroll.
 */

(function () {
  'use strict';

  var SEL_DIALOG = '[data-md-zoom]';
  var SEL_TRILHO = '[data-md-zoom-trilho]';
  var SEL_ITEM = '[data-md-zoom-item]';
  var SEL_MINI = '[data-md-zoom-mini]';
  var SEL_FECHAR = '[data-md-zoom-fechar]';
  var SEL_GATILHO =
    '.product__media-item, .md-zoom-abrir, [data-md-zoom-abrir]';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return (root || document).querySelectorAll(sel);
  }

  function abrir(dialog, indice) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      try {
        if (!dialog.open) dialog.showModal();
      } catch (e) {
        dialog.setAttribute('open', '');
      }
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('md-zoom-aberto');
    irPara(dialog, indice || 0, true);
  }

  function fechar(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function') {
      try {
        dialog.close();
      } catch (e) {
        dialog.removeAttribute('open');
      }
    } else {
      dialog.removeAttribute('open');
    }
    document.documentElement.classList.remove('md-zoom-aberto');
  }

  function irPara(dialog, indice, instante) {
    var trilho = qs(SEL_TRILHO, dialog);
    if (!trilho) return;
    var itens = qsa(SEL_ITEM, dialog);
    if (!itens.length) return;
    var i = Math.max(0, Math.min(indice, itens.length - 1));
    var alvo = itens[i];
    if (!alvo) return;
    var left = alvo.offsetLeft;
    if (instante) {
      trilho.scrollLeft = left;
    } else {
      trilho.scrollTo({ left: left, behavior: 'smooth' });
    }
    atualizarMinis(dialog, i);
  }

  function atualizarMinis(dialog, indice) {
    var minis = qsa(SEL_MINI, dialog);
    for (var i = 0; i < minis.length; i++) {
      var alvo = parseInt(
        minis[i].getAttribute('data-md-zoom-alvo') || '0',
        10
      );
      if (alvo === indice) {
        minis[i].setAttribute('aria-current', 'true');
        if (typeof minis[i].scrollIntoView === 'function') {
          try {
            minis[i].scrollIntoView({
              block: 'nearest',
              inline: 'nearest'
            });
          } catch (e) {}
        }
      } else {
        minis[i].removeAttribute('aria-current');
      }
    }
  }

  function indiceVisivel(dialog) {
    var trilho = qs(SEL_TRILHO, dialog);
    if (!trilho) return 0;
    var itens = qsa(SEL_ITEM, dialog);
    if (!itens.length) return 0;
    var meio = trilho.scrollLeft + trilho.clientWidth / 2;
    var melhor = 0;
    var menorDist = Infinity;
    for (var i = 0; i < itens.length; i++) {
      var centro = itens[i].offsetLeft + itens[i].offsetWidth / 2;
      var d = Math.abs(centro - meio);
      if (d < menorDist) {
        menorDist = d;
        melhor = i;
      }
    }
    return melhor;
  }

  function gatilhoDeveAbrir(el, target) {
    if (!target || !target.closest) return true;
    // Nao abre se clicou num controle de video, link interno ou botao
    if (target.closest('video') && !target.closest('.md-zoom-abrir, [data-md-zoom-abrir]')) {
      return false;
    }
    if (target.closest('a[href]:not(.md-zoom-abrir)')) {
      return false;
    }
    if (target.closest('button:not(.md-zoom-abrir)') && !target.closest('[data-md-zoom-abrir]')) {
      return false;
    }
    return true;
  }

  function initDialog(dialog) {
    if (dialog.dataset.mdZoomInit === '1') return;
    dialog.dataset.mdZoomInit = '1';

    var fecharBtn = qs(SEL_FECHAR, dialog);
    if (fecharBtn) {
      fecharBtn.addEventListener('click', function () {
        fechar(dialog);
      });
    }

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('md-zoom-aberto');
    });

    dialog.addEventListener('cancel', function () {
      document.documentElement.classList.remove('md-zoom-aberto');
    });

    var trilho = qs(SEL_TRILHO, dialog);
    if (trilho) {
      var raf = 0;
      trilho.addEventListener(
        'scroll',
        function () {
          if (raf) return;
          raf = window.requestAnimationFrame(function () {
            raf = 0;
            atualizarMinis(dialog, indiceVisivel(dialog));
          });
        },
        { passive: true }
      );
    }

    var minis = qsa(SEL_MINI, dialog);
    for (var i = 0; i < minis.length; i++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          var alvo = parseInt(
            btn.getAttribute('data-md-zoom-alvo') || '0',
            10
          );
          irPara(dialog, isNaN(alvo) ? 0 : alvo, false);
        });
      })(minis[i]);
    }
  }

  function initGatilhos(dialog) {
    var gatilhos = qsa(SEL_GATILHO);
    for (var i = 0; i < gatilhos.length; i++) {
      (function (el, idx) {
        if (el.dataset.mdZoomGatilhoInit === '1') return;
        el.dataset.mdZoomGatilhoInit = '1';
        el.addEventListener('click', function (ev) {
          if (!gatilhoDeveAbrir(el, ev.target)) return;
          ev.preventDefault();
          var raw = el.getAttribute('data-md-zoom-indice');
          var alvo = raw === null ? idx : parseInt(raw, 10);
          abrir(dialog, isNaN(alvo) ? 0 : alvo);
        });
      })(gatilhos[i], i);
    }
  }

  function initAll() {
    var dialogs = qsa(SEL_DIALOG);
    for (var i = 0; i < dialogs.length; i++) {
      initDialog(dialogs[i]);
      initGatilhos(dialogs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  window.MdZoom = {
    abrir: function (indice) {
      var d = document.querySelector(SEL_DIALOG);
      if (d) abrir(d, indice || 0);
    },
    fechar: function () {
      var d = document.querySelector(SEL_DIALOG);
      if (d) fechar(d);
    }
  };
})();
